import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { buildOverviewItemId } from 'site-modules/personalized-search/utils/build-overview-item-id';
import { COMPONENTS } from 'site-modules/personalized-search/constants/components';
import { SearchRenderer } from 'site-modules/personalized-search/search-renderer/search-renderer';
import { CollapsibleOverviewItem } from 'site-modules/personalized-search/components/overview/collapsible-overview-item';

export const OverviewItem = memo(
  ({ componentParams, parentComponentName, withCollapse = false, componentPath, onRendered = noop, ...restProps }) => {
    const Component = withCollapse ? CollapsibleOverviewItem : SearchRenderer;
    const { make, model, year, trim } = componentParams.header;

    const id = buildOverviewItemId({ year, make, model, trim });

    useEffect(() => {
      onRendered();
    }, [onRendered]);

    return (
      <div id={id}>
        <Component
          componentParams={componentParams}
          parentComponentName={COMPONENTS.OVERVIEW_ITEM}
          withCollapse={withCollapse}
          componentPath={componentPath}
          {...restProps}
          trackActionStart={!withCollapse}
        />
      </div>
    );
  }
);

OverviewItem.propTypes = {
  withCollapse: PropTypes.bool,
  componentParams: PropTypes.shape({}).isRequired,
  parentComponentName: PropTypes.string.isRequired,
  componentPath: PropTypes.string.isRequired,
  onRendered: PropTypes.func,
};
